import { render, staticRenderFns } from "./MyExamResultsComponent.vue?vue&type=template&id=bfdbb54c&"
import script from "./MyExamResultsComponent.vue?vue&type=script&lang=js&"
export * from "./MyExamResultsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports